import Vue from 'vue'
import Router from 'vue-router'
import HelloWorld from '@/components/HelloWorld'
import seasoncarddetails from '@/components/SeasonCardDetails'
import coursedetails from '@/components/CourseDetails'
import packagedetails from '@/components/PackageDetails'
import hoteldetails from '@/components/HotelDetails'
import campsitedetails from '@/components/CampsiteDetails'
import snowticketdetails from '@/components/SnowTicketDetails'
import eventsdetails from '@/components/EventsDetails'
import cloudtopdetails from '@/components/CloudTopDetails'
import {
  compare
} from 'semver'

Vue.use(Router)

export default new Router({
  routes: [{
      path: '/',
      name: 'HelloWorld',
      component: HelloWorld
    },
    {
      path: '/SeasonCardDetails',
      name: 'seasoncarddetails',
      component: seasoncarddetails,
      meta: {
        title: '季卡详情'
      }
    },
    {
      path: '/SeasonCardHead',
      name: 'seasoncardhead',
      component: () => import('@/components/SeasonCardHead'),
      meta: {
        title: '季卡详情'
      }
    },
    {
      path: '/CourseDetails',
      name: 'coursedetails',
      component: coursedetails,
      meta: {
        title: '课程详情'
      }
    },
    {
      path: '/CourseHead',
      name: 'coursehead',
      component: () => import('@/components/CourseHead'),
      meta: {
        title: '课程详情'
      }
    },
    {
      path: '/PackageDetails',
      name: 'packagedetails',
      component: packagedetails,
      meta: {
        title: '套餐详情'
      }
    },
    {
      path: '/PackageHead',
      name: 'packagehead',
      component: () => import('@/components/PackageHead'),
      meta: {
        title: '套餐详情'
      }
    },
    {
      path: '/HotelDetails',
      name: 'hoteldetails',
      component: hoteldetails,
      meta: {
        title: '酒店详情'
      }
    },
    {
      path: '/HotelHead',
      name: 'hotelhead',
      component: () => import('@/components/HotelHead'),
      meta: {
        title: '酒店详情'
      }
    },
    {
      path: '/CampsiteDetails',
      name: 'campsitedetails',
      component: campsitedetails,
      meta: {
        title: '营地详情'
      }
    },
    {
      path: '/CampsiteHead',
      name: 'campsitehead',
      component: () => import('@/components/CampsiteHead'),
      meta: {
        title: '营地详情'
      }
    },
    {
      path: '/SnowTicketDetails',
      name: 'snowticketdetails',
      component: snowticketdetails,
      meta: {
        title: '雪票详情'
      }
    },
    {
      path: '/SnowTicketHead',
      name: 'snowtickethead',
      component: () => import('@/components/SnowTicketHead'),
      meta: {
        title: '雪票详情'
      }
    },
    {
      path: '/EventsDetails',
      name: 'eventsdetails',
      component: eventsdetails,
      meta: {
        title: '活动详情'
      }
    },
    {
      path: '/CloudTopDetails',
      name: 'cloudtopdetails',
      component: cloudtopdetails,
      meta: {
        title: '头条详情'
      }
    },
    {
      path: '/SnowTicketBooking',
      name: 'snowticketbooking',
      component: () => import('@/components/SnowTicketBooking'),
      meta: {
        title: '预订须知'
      }
    },
    {
      path: '/SeasonCardBooking',
      name: 'seasoncardbooking',
      component: () => import('@/components/SeasonCardBooking'),
      meta: {
        title: '预订须知'
      }
    },

    {
      path: '/OthersBooking',
      name: 'othersbooking',
      component: () => import('@/components/othersbooking'),
      meta: {
        title: '预订须知'
      }
    },
    {
      path: '/Micemeetinghall',
      name: 'micemeetinghall',
      component: () => import('@/components/Micemeetinghall'),
      meta: {
        title: '会议展厅'
      }
    },
    {
      path: '/Miceteambuilding',
      name: 'miceteambuilding',
      component: () => import('@/components/Miceteambuilding'),
      meta: {
        title: '团建活动'
      }
    },
    {
      path: '/CoachDetails',
      name: 'coachdetails',
      component: () => import('@/components/CoachInfo'),
      meta: {
        title: '教练详情'
      }
    },

    {
      path: '/Traffic',
      name: 'traffic',
      component: () => import('@/components/Traffic'),
      meta: {
        title: '雪道列表'
      }
    },
    {
      path: '/RestaurantDetail',
      name: 'RestaurantDetail',
      component: () => import('@/components/RestaurantDetail'),
      meta: {
        title: '餐厅详情'
      }
    },
    {
      path: '/VR',
      name: 'VR',
      component: () => import('@/components/VR'),
      meta: {
        title: 'VR'
      }
    },
    {
      path: '/HouseType',
      name: 'HouseType',
      component: () => import('@/components/HouseType'),
      meta: {
        title: '酒店房型'
      }
    },
    {
      path: '/CustomerMessage',
      name: 'CustomerMessage',
      component: () => import('@/components/CustomerMessage'),
      meta: {
        title: '信息'
      }
    },
    {
      path: '/ActivityCard',
      name: 'ActivityCard',
      component: () => import('@/components/ActivityCard'),
      meta: {
        title: '活动卡片'
      }
    },
    {
      path: '/MeetingRoomCard',
      name: 'MeetingRoomCard',
      component: () => import('@/components/MeetingRoomCard'),
      meta: {
        title: '会议室季卡'
      }
    },
    {
      path: '/Activity',
      name: 'Activity',
      component: () => import('@/components/Activity'),
      meta: {
        title: '活动'
      }
    },
    {
      path: '/MeetingRoom',
      name: 'MeetingRoom',
      component: () => import('@/components/MeetingRoom'),
      meta: {
        title: '会议室'
      }
    },
    {
      path: '/Traffic2',
      name: 'Traffic2',
      component: () => import('@/components/Traffic2'),
      meta: {
        title: '交通线路'
      }
    },
    {
      path: '/UserAgreement',
      name: 'UserAgreement',
      component: () => import('@/components/UserAgreement'),
      meta: {
        title: '用户协议'
      }
    },
    {
      path: '/PrivacyPolicy',
      name: 'PrivacyPolicy',
      component: () => import('@/components/PrivacyPolicy'),
      meta: {
        title: '隐私政策'
      }
    },
    {
      path: '/weather',
      name: 'weather',
      component: () => import('@/components/weather'),
      meta: {
        title: '天气'
      }
    },
    {
      path: '/SnowPathPic',
      name: 'SnowPathPic',
      component: () => import('@/components/SnowPathPic'),
      meta: {
        title: '雪道详情'
      }
    },
    {
      path: '/BannerDetails',
      name: 'BannerDetails',
      component: () => import('@/components/BannerDetails'),
      meta: {
        title: '密苑雪道'
      }
    },
    {
      path: '/ClubDetails',
      name: 'ClubDetails',
      component: () => import('@/components/ClubDetails'),
      meta: {
        title: '俱乐部详情'
      }
    },
    {
      path: '/HeadImg',
      name: 'HeadImg',
      component: () => import('@/components/HeadImg'),
      meta: {
        title: '头图'
      }
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js